import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';
import { ModalContainerView } from '../../components/ModalContainerView';
import { AccountsTransfersMain } from './AccountsTransfersMain';
import { AccountsTransfersConfirm } from './AccountsTransfersConfirm';
import { AccountsTransfersPlaced } from './AccountsTransfersPlaced';
import { AccountSelectScreen } from './AccountSelect.screen';
import { AccountsTransfersStackParamList, AccountsTransfersStackRoutes } from './type';

const AccountsTransfersStack = createNativeStackNavigator<AccountsTransfersStackParamList>();

export const AccountsTransfersNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.AccountsTransfers>> = ({
  route
}) => {
  const { account, tab, func, refresh, record, onChangeView, onSelect, asset, otherSelectedId, subaccountFlag, balanceAllFlag } =
    route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const [data, setData] = useState(undefined);
  const onData = (data: any) => {
    setData(data);
  };

  const [returnData, setReturnData] = useState(undefined);
  const onReturnData = (data: any) => {
    setReturnData(data);
  };

  return (
    <ModalContainerView dimensions={dimensions}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <AccountsTransfersStack.Navigator
          initialRouteName={AccountsTransfersStackRoutes.Main}
          screenOptions={{
            presentation: layout.isMobile ? 'modal' : 'transparentModal',
            headerShown: false
          }}>
          <AccountsTransfersStack.Screen
            name={AccountsTransfersStackRoutes.Main}
            component={AccountsTransfersMain}
            initialParams={{ onLayout, account, tab, onData, onReturnData, func, refresh, record }}
            options={{ headerShown: false }}
          />
          <AccountsTransfersStack.Screen
            name={AccountsTransfersStackRoutes.Confirm}
            component={AccountsTransfersConfirm}
            initialParams={{ onLayout, account, tab, data, onReturnData, func, refresh, onChangeView, record }}
            options={{
              presentation: 'transparentModal',
              headerShown: false,
              contentStyle: {
                backgroundColor: 'transparent'
              }
            }}
          />
          <AccountsTransfersStack.Screen
            name={AccountsTransfersStackRoutes.Placed}
            component={AccountsTransfersPlaced}
            initialParams={{ onLayout, account, tab, data, returnData, record }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
          <AccountsTransfersStack.Screen
            name={AccountsTransfersStackRoutes.AccountSelect}
            component={AccountSelectScreen}
            initialParams={{ onLayout, onSelect, asset, otherSelectedId, onChangeView, subaccountFlag, balanceAllFlag }}
            options={{ presentation: 'transparentModal', headerShown: false }}
          />
        </AccountsTransfersStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
